import React, { Fragment } from 'react'
import {
    Card, Form, Col, Row, ListGroup, ListGroupItem
} from 'react-bootstrap';

import 'react-toastify/dist/ReactToastify.css';




export const CardRouteParamSelection = ({ routeDataParameters, setRouteDataParameter,routeDataParameter }) => {

    const handleClick = (selectedR) => {
        setRouteDataParameter({...selectedR})
    }

    if (!!!routeDataParameters) {
        return <></>
    }


    return (

        <Fragment>
            <Card
                style={{
                    position: 'absolute',
                    top: 255,
                    left: 20,
                    width: '15vw',
                    alignContent: 'center'
                }}>

                <ListGroup variant="flush">
                    <ListGroupItem>

                        <Row>
                            <Col><h6>Select route parameter:</h6></Col>
                        </Row>
                        <Form>
                            {
                                routeDataParameters.map((r, idx) =>
                                    <Form.Check // prettier-ignore
                                        type='radio'
                                        key={`routeParam-${idx}`}
                                        name='group1'
                                        checked = {r.display_name===routeDataParameter.display_name}
                                        label={r.display_name}
                                        onChange={() => handleClick(r)}
                                        id={r.name}
                                    />
                                )
                            }
                        </Form>
                    </ListGroupItem>
                </ListGroup>

                {/* </Card.Body> */}
            </Card>

        </Fragment>

    )
}